(function() {
    function funcReady() {
        $('.KRP0029').buildCommonUI();

        vcui.require(['ui/carousel'], function () {
            var $section = $('.KRP0029');
            var $sectionCarousel = $section.find(".ui_carousel_slider");
            
            if ($sectionCarousel.hasClass('ui_carousel_initialized')) {
                $sectionCarousel.vcCarousel('destroy');
                $sectionCarousel.addClass('ui_carousel_slider');
            }

            $sectionCarousel.each(function(cdx, slide){
                $(slide).vcCarousel({
                    infinite: false,
                    pauseOnHover:false,
                    pauseOnFocus:false,
                    swipeToSlide: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    speed: 150,
                    touchThreshold: 100,
                    responsive: [{
                        breakpoint: 20000,
                        settings: {
                            slidesToShow: 3
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: ($(slide).find(".ui_carousel_slide").length === 1) ? 1 : 1.2
                        }
                    }]
                });
            });
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRP0029', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP0029')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP0029')) return false;
        funcReady();
    });
})();
